import React, {useMemo, useState} from 'react';
import {Stack, Typography, Button, Box} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useOutletContext } from 'react-router-dom';
import { When } from "react-if";
import ReportsBackIcon from "../../../../assets/icons/reports-back-icon";
import {CsvUpload} from "./csv-upload";
import {FileNameInput} from "./name-input";
import dayjs from 'dayjs';

export const BulkSafetyReportScreen: React.FC = () => {
    interface ContextType {
        setReportTitle: (title: string) => void;
        setReportDescText: (desc: string) => void;
    }
    const { setReportTitle, setReportDescText } = useOutletContext<ContextType>();
    useMemo(() => {
        setReportTitle("Visit Risk Review");
        setReportDescText("Upload a list of addresses to generate detailed risk reports for each location, helping you assess potential vulnerabilities and safety concerns.");
    }, []);

    const SCREENS = {
        CSV_UPLOAD: 0,
        ADD_REPORT_NAME: 1,
        DOWNLOAD: 2
    }

    const [screenCount, setScreenCount] = React.useState<number>(SCREENS.CSV_UPLOAD);
    const [fileName, setFileName] = React.useState<string>('');

    const [file64, setFile64] = useState<string | null>(null);
    const [selectedFile, setSelectedFile] = useState<File|undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [addressesToImport, setAddressesToImport] = useState<string[]>([]);

    const handleBack = () => {
        if(screenCount === SCREENS.CSV_UPLOAD){
            navigate("/reports/")
        }else{
            resetToHome();
        }

    }

    const handleNext = () => {
        setScreenCount(screenCount+1);
    }

    const resetToHome = () => {
        setScreenCount(SCREENS.CSV_UPLOAD);
        setAddressesToImport([]);
        setFile64(null);
        setSelectedFile(undefined);
        setIsLoading(false);
        setFileName('');
    }

    const navigate = useNavigate();
    return (
        <Stack>
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: 'left',
                textAlign: 'left',
                marginTop: 4,
                marginBottom: 6
            }}>
                <Button
                    variant="outlined"
                    color="inherit"
                    onClick={handleBack}
                    disabled={false}
                    sx={{
                        border : 0,
                        padding:1,
                        boxShadow : '0 0 2px 0 rgba(145, 158, 171, 0.24),0 16px 32px -4px rgba(145, 158, 171, 0.24)'
                    }}
                >
                    <ReportsBackIcon/>
                    <Typography fontWeight={400} fontSize={14} color={'black'} marginLeft={1}>
                        Back
                    </Typography>
                </Button>
            </Box>
            <When condition={screenCount === SCREENS.CSV_UPLOAD}>
                <CsvUpload
                    handleNext={handleNext}
                    addressesToImport={addressesToImport}
                    setAddressesToImport={setAddressesToImport}
                    file64={file64}
                    setFile64={setFile64}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                />
            </When>
            <When condition={screenCount === SCREENS.ADD_REPORT_NAME}>
                <FileNameInput
                    selectedFile={selectedFile}
                    handleBack={handleBack}
                    fileName={fileName} setFileName={setFileName}
                />
            </When>
        </Stack>
    )
}